<template>
    <modal @close="closePurgedUsers" hide-footer>
        <div>
            <h2 class="td-h2">Purged Users</h2>
        </div>
        <div class="td-table-container mt-5" v-if="sortedArray && sortedArray.length > 0">
            <table cellspacing="0" cellpadding="0" class="td-table">
                <thead>
                    <tr class="table-header">
                        <th>
                            <span v-if="sortNameAsc" @click="sortBy('name_desc')">
                                Name
                                <icon class="ml-1" name="faCaretUp" type="solid"></icon>
                            </span>
                            <span v-if="sortNameDesc" @click="sortBy('name_asc')">
                                Name
                                <icon class="ml-1" name="faCaretDown" type="solid"></icon>
                            </span>
                            <span v-if="!sortNameAsc && !sortNameDesc" @click="sortBy('name_asc')">
                                Name
                            </span>
                        </th>
                        <th>
                            <span v-if="sortEmailAsc" @click="sortBy('email_desc')">
                                Email
                                <icon class="ml-1" name="faCaretUp" type="solid"></icon>
                            </span>
                            <span v-if="sortEmailDesc" @click="sortBy('email_asc')">
                                Email
                                <icon class="ml-1" name="faCaretDown" type="solid"></icon>
                            </span>
                            <span v-if="!sortEmailAsc && !sortEmailDesc" @click="sortBy('email_asc')">
                                Email
                            </span>
                        </th>
                        <th>
                            <span v-if="sortMobileAsc" @click="sortBy('mobile_desc')">
                                Mobile
                                <icon class="ml-1" name="faCaretUp" type="solid"></icon>
                            </span>
                            <span v-if="sortMobileDesc" @click="sortBy('mobile_asc')">
                                Mobile
                                <icon class="ml-1" name="faCaretDown" type="solid"></icon>
                            </span>
                            <span v-if="!sortMobileAsc && !sortMobileDesc" @click="sortBy('mobile_asc')">
                                Mobile
                            </span>
                        </th>
                        <th>
                            <span v-if="sortStatusAsc" @click="sortBy('status_desc')">
                                Status
                                <icon class="ml-1" name="faCaretUp" type="solid"></icon>
                            </span>
                            <span v-if="sortStatusDesc" @click="sortBy('status_asc')">
                                Status
                                <icon class="ml-1" name="faCaretDown" type="solid"></icon>
                            </span>
                            <span v-if="!sortStatusAsc && !sortStatusDesc" @click="sortBy('status_asc')">
                                Status
                            </span>
                        </th>
                        <th>
                            <span v-if="sortLastModifiedAsc" @click="sortBy('lastmodified_desc')">
                                Last Modified
                                <icon class="ml-1" name="faCaretUp" type="solid"></icon>
                            </span>
                            <span v-if="sortLastModifiedDesc" @click="sortBy('lastmodified_asc')">
                                Last Modified
                                <icon class="ml-1" name="faCaretDown" type="solid"></icon>
                            </span>
                            <span v-if="!sortLastModifiedAsc && !sortLastModifiedDesc" @click="sortBy('lastmodified_asc')">
                                Last Modified
                            </span>
                        </th>
                        <th>
                            <span v-if="sortRightsAsc" @click="sortBy('rights_desc')">
                                Rights
                                <icon class="ml-1" name="faCaretUp" type="solid"></icon>
                            </span>
                            <span v-if="sortRightsDesc" @click="sortBy('rights_asc')">
                                Rights
                                <icon class="ml-1" name="faCaretDown" type="solid"></icon>
                            </span>
                            <span v-if="!sortRightsAsc && !sortRightsDesc" @click="sortBy('rights_asc')">
                                Rights
                            </span>
                        </th>
                        <th class="td-text-right"></th>
                    </tr>
                </thead>
                <tbody v-if="!isLoading && sortedArray.length > 0" v-for="user in sortedArray" class="rows-container">
                    <tr class="table-row main-row">
                        <td class="name" v-if="user.status != 5">
                            <a :href="getViewUserLink(user)" style="text-decoration: none;">
                                <h2 class="td-h5 mt-0">
                                    <img class="mr-1" :src="getProfilePicture(user)" style="max-height: 40px; max-width: auto; vertical-align: middle;" />
                                    {{ user.firstName }} {{ user.lastName }}
                                </h2>
                            </a>
                        </td>
                        <td v-else>
                            <h2 class="td-h5 mt-0">
                                <img class="mr-1" :src="getProfilePicture(user)" style="max-height: 40px; max-width: auto; vertical-align: middle;" />
                                {{ user.firstName }} {{ user.lastName }}
                            </h2>
                        </td>
                        <td class="email">
                            {{ user.email }}
                        </td>
                        <td class="mobile">
                            {{ formatPhoneString(user.mobile) }}
                        </td>
                        <td class="status">
                            {{ getStatus(user.status) }}
                        </td>
                        <td class="modified">
                            {{ dateDisplay(user.modified) }}
                        </td>
                        <td class="roles">
                            {{ getRole(user) }}
                        </td>

                        <td>
                            <a :href="getViewUserLink(user)" v-if="user.status != 5" class="td-btn secondary-outlined slim" title="View">
                                View
                            </a>
                        </td>
                    </tr>
                </tbody>
                <tbody v-if="isLoading">
                    <tr><th colspan="5"><div class="loading loading-table"><icon name="faSpinner" type="solid" spin></icon></div></th></tr>
                </tbody>
            </table>
        </div>
        <div v-else class="mt-5">
            <div class="td-banner warning no-icon mt-2">
                <p>No users found.</p>
            </div>
        </div>
    </modal>

</template>

<script>
    import script from './PurgedUsers';
    export default script;
</script>

<style lang="less">
    @import './PurgedUsers.less';
</style>